'use client'

import Link from 'next/link'
import { useState } from 'react'
import SafeImage from './SafeImage'
import AddToCartModal from './AddToCartModal'
import {
  catalogProducts,
  formatTryPrice,
  type CatalogProduct,
} from '@/data/catalog'
import { addToCart } from '@/lib/cart'

export default function AkustikPanellerCatalog() {
  const [added, setAdded] = useState<CatalogProduct | null>(null)

  const handleAdd = (product: CatalogProduct) => {
    addToCart({
      slug: product.slug,
      name: product.name,
      href: product.href,
      image: product.image,
      price: product.price,
    })
    setAdded(product)
  }

  return (
    <>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
        {catalogProducts.map((product) => (
          <div key={product.slug} className="flex flex-col">
            <article className="group border border-gray-200 bg-white flex flex-col flex-1">
              <Link
                href={product.href}
                className="block relative aspect-square overflow-hidden bg-gray-50 border-b border-gray-200"
              >
                <SafeImage
                  src={product.image}
                  alt={`${product.name} - Doku Akustik`}
                  fill
                  sizes="(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 25vw"
                  className="object-cover transition-transform duration-500 group-hover:scale-[1.03]"
                />
              </Link>

              <div className="flex flex-col flex-1 p-3.5 md:p-4">
                <Link href={product.href} className="block">
                  <h3 className="text-[#b45309] font-semibold text-sm md:text-[15px] leading-snug hover:underline">
                    {product.name}
                  </h3>
                </Link>
                <Link href={product.href} className="mt-2 block">
                  <p className="text-[#111827] font-bold text-sm md:text-base">
                    {formatTryPrice(product.price)}{' '}
                    <span className="font-medium text-[#4b5563]">+ KDV</span>
                  </p>
                </Link>
              </div>
            </article>

            <button
              type="button"
              onClick={() => handleAdd(product)}
              className="mt-2.5 w-full min-h-[48px] bg-[#f7941d] hover:bg-[#e8850f] text-white font-semibold text-sm transition-colors"
            >
              Sepete Ekle
            </button>
          </div>
        ))}
      </div>

      {added ? (
        <AddToCartModal product={added} onClose={() => setAdded(null)} />
      ) : null}
    </>
  )
}
